var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27039 2.06004L5.52039 1.03004C5.23539 0.925044 4.77039 0.925044 4.48539 1.03004L1.73539 2.06004C1.20539 2.26004 0.775391 2.88004 0.775391 3.44504V7.49504C0.775391 7.90004 1.04039 8.43504 1.36539 8.67504L4.11539 10.73C4.60039 11.095 5.39539 11.095 5.88039 10.73L8.63039 8.67504C8.95539 8.43004 9.22039 7.90004 9.22039 7.49504V3.44504C9.22539 2.88004 8.79539 2.26004 8.27039 2.06004ZM6.74039 4.86004L4.59039 7.01004C4.51539 7.08504 4.42039 7.12004 4.32539 7.12004C4.23039 7.12004 4.13539 7.08504 4.06039 7.01004L3.26039 6.20004C3.11539 6.05504 3.11539 5.81504 3.26039 5.67004C3.40539 5.52504 3.64539 5.52504 3.79039 5.67004L4.33039 6.21004L6.21539 4.32504C6.36039 4.18004 6.60039 4.18004 6.74539 4.32504C6.89039 4.47004 6.89039 4.71504 6.74039 4.86004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldPass);
export default __webpack_public_path__ + "static/media/shield-pass.36bbcc29955c339ea2b297749018e1c9.svg";
export { ForwardRef as ReactComponent };